/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Calm_Cod_FlowInputs */

const en_pale_calm_cod_flow = /** @type {(inputs: Pale_Calm_Cod_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goals`)
};

const de_pale_calm_cod_flow = /** @type {(inputs: Pale_Calm_Cod_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziele`)
};

/**
* | output |
* | --- |
* | "Goals" |
*
* @param {Pale_Calm_Cod_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_calm_cod_flow = /** @type {((inputs?: Pale_Calm_Cod_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Calm_Cod_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_calm_cod_flow(inputs)
	return de_pale_calm_cod_flow(inputs)
});